import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ListConfig } from '../active-cases-list/active-cases-list.interface';
import { AjaxService } from 'src/app/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-table-grid',
  templateUrl: './common-table-grid.component.html',
  styleUrls: ['./common-table-grid.component.less']
})
export class CommonTableGridComponent implements OnInit {
  @Input() datalist: any[] = [];
  @Input() fieldsConfig!: ListConfig;
  @Output() sortChange = new EventEmitter<{ sortField: string, sortOrder: number }>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() editAction = new EventEmitter<any>();
  @Output() viewFilesAction = new EventEmitter<any>();
  @Output() payFeesAction = new EventEmitter<any>();
  @Output() invoiceDownloadAction = new EventEmitter<any>();
  @Output() checkPaymentStatusAction = new EventEmitter<any>();
  @Output() onDeleteCaseAction = new EventEmitter<any>();
  @Output() onConsultantNeedMoreInfoAction = new EventEmitter<any>();
  @Output() onConsultantAddVoiceNotesAction = new EventEmitter<any>();
  @Output() onConsultantAcceptCaseAction = new EventEmitter<any>();
  @Output() onConsultantRejectCaseAction = new EventEmitter<any>();
  @Output() clinicianNotesAddAction = new EventEmitter<any>();
  @Output() addCaseSummaryAction = new EventEmitter<any>();
  @Output() assignClinicianAction = new EventEmitter<any>();
  @Output() assignConsultantAction = new EventEmitter<any>();
  @Output() addAdminNotesAction = new EventEmitter<any>();
  @Output() virtualConsultationAction = new EventEmitter<any>();
  @Output() uploadFilePopupAction = new EventEmitter<any>();
  selectedProduct: any = null;
  searchTerm: string = '';
  showPaypalLinkDialog: boolean = false;
  showLink: boolean = false;
  paymentLink:string='';
  amount=0;
  @ViewChild('nameTemplate', { static: true })
  private nameTemplate!: TemplateRef<any>;

  @ViewChild('statusTemplate', { static: true })
  private statusTemplate!: TemplateRef<any>;

  @ViewChild('casePDFTemplate', { static: true })
  private casePDFTemplate!: TemplateRef<any>;

  @ViewChild('caseSummaryTemplate', { static: true })
  private caseSummaryTemplate!: TemplateRef<any>;

  @ViewChild('caseIdTemplate', { static: true })
  private caseIdTemplate!: TemplateRef<any>;

  @ViewChild('dateCreatedTemplate', { static: true })
  private dateCreatedTemplate!: TemplateRef<any>;

  @ViewChild('dateModifiedTemplate', { static: true })
  private dateModifiedTemplate!: TemplateRef<any>;

  constructor(private _ajaxService: AjaxService,
    private _router: Router,
    private _confirmationService: ConfirmationService,
    private _translateService: TranslateService,
    private messageService: MessageService,
    private _dataService: CommonDataService) { }

  ngOnInit(): void {

  }
  onSort(event: any): void {
    console.log("Sort Clicked"+JSON.stringify(event));
    const sortField = event.field;
    const sortOrder = event.order;
    this.sortChange.emit({ sortField, sortOrder });
  }
  onSearch(): void {
    this.searchChange.emit(this.searchTerm); // Emit search term to parent
  }
  getTemplate(template: any): TemplateRef<any> {

    switch (template) {
      case 'name':
        return this.nameTemplate;
      case 'status':
        return this.statusTemplate;  
      case 'casePdf':
      return this.casePDFTemplate; 
      case 'caseSummary':
      return this.caseSummaryTemplate
      case 'caseId':
      return this.caseIdTemplate; 
      case 'createdDate':
      return this.dateCreatedTemplate;
      case 'modifiedDate':
      return this.dateModifiedTemplate;  

      default:
        return null;
    }
  }
  getReviewPdf(data: any) {
    this._dataService.isLoading = true;
    this._ajaxService.post('/case/getCaseDocumentURL', { "CaseId": data.CaseId || data.Case.CaseId }).subscribe(result => {
      this._dataService.isLoading = false;
      if (result.data) {
        window.open(result.data);
      }
    },
      error => {
        this._dataService.isLoading = false;
      });
  }
  getSummaryPdf(data: any) {
    this._dataService.isLoading = true;
    this._ajaxService.post('/case/getById',{"CaseId": data.CaseId || data.Case.CaseId}).subscribe(async(resp)=>{
      if(resp.data.CaseSummaryDocument==null){
      this._dataService.isLoading = false;
      return this.messageService.add({ severity: 'error', summary: 'Case Summary is not prepared yet'});
    }
     await this._ajaxService.post('/upload/getDocURL',{"CaseId": data.CaseId || data.Case.CaseId,"key":resp.data.CaseSummaryDocument.Key.toString()}).subscribe((response)=>{
      this._dataService.isLoading = false;
      window.open(response.data);
      },
        error => {
          this._dataService.isLoading = false;
        });
    })
    
  }
  onEdit(product: any): void {
    this.editAction.emit(product); // Pass the product to the parent
  }
  onRowSelect(event: any) {
    this.selectedProduct = event.data; // Set the selected product
    console.log("Data"+JSON.stringify(this.selectedProduct));
  }

  onRowUnselect() {
    this.selectedProduct = null; // Clear selection
  }
  async onExport(){
    this._dataService.isLoading = true;
    await this._ajaxService.post('/case/downloadCaseCsv',{},{ responseType: 'blob' }).subscribe(async(resp)=>{
      saveAs(resp, 'data.csv');
      this._dataService.isLoading=false;
    })
  }
  onViewFiles(product: any): void {
    this.viewFilesAction.emit(product); // Pass the product to the parent
  }
  onPayFees(product: any): void {
    this.payFeesAction.emit(product); // Pass the product to the parent
  }
  checkPaymentStatus(product: any): void {
    this.checkPaymentStatusAction.emit(product); // Pass the product to the parent
  }
  deleteCaseAction(product:any):void{
    this.onDeleteCaseAction.emit(product);
  }
  consultantNeedMoreInfoAction(product:any):void{
    this.onConsultantNeedMoreInfoAction.emit(product);
  }
  consultantAddVoiceNotesAction(product:any):void{
    this.onConsultantAddVoiceNotesAction.emit(product);
  }
  consultantAcceptCase(product:any):void{
    this.onConsultantAcceptCaseAction.emit(product);
  }
  consultantRejectCase(product:any):void{
    this.onConsultantRejectCaseAction.emit(product);
  }
  invoiceDownload(product:any):void{
    this.invoiceDownloadAction.emit(product);
  }
  get loggedInUserId() {
    return this._dataService?.userDetails?.data?.Id;
  }
  clinicianAddNotes(product:any):void{
    this.clinicianNotesAddAction.emit(product);
  }
  addCaseSummary(product:any):void{
    this.addCaseSummaryAction.emit(product);
  }
  viewRedactCasePDF(data: any){
    this._dataService.isLoading = true;
    this._ajaxService.post('/case/getCaseDocumentURL', { "CaseId": data.CaseId || data.Case.CaseId ,"ShowRedact":true}).subscribe(result => {
      this._dataService.isLoading = false;
      if (result.data) {
        window.open(result.data);
      }
    },
      error => {
        this._dataService.isLoading = false;
      });
  }
  generatePaypalPaymentLink(data:any){
    this.showPaypalLinkDialog= true;
  }
  regenerateCasePDF(data: any) {
    this._dataService.isLoading = true;
    const reqBody = {
      CaseId: data.CaseId,
      regenerate: true
    }
    this._ajaxService.post('/case/getCaseDocumentURL', reqBody).subscribe((resp) => {
      this._dataService.isLoading = false;
      if (resp.data) {
        window.open(resp.data);
      }
    })
  }
  generatePaymentLink(){
    this._dataService.isLoading= true;
    this._ajaxService.get(`/miscellaneous/generatePaypalPaymentLink?caseId=${this.selectedProduct.CaseId}&amount=${this.amount}`).subscribe((resp) => {
      this._dataService.isLoading = false;
      if (resp.invoiceLink) {
          this.paymentLink= resp.invoiceLink;
          this.showLink= true;
      }
    })
  }
  reasignClinician(product:any):void{
    this.assignClinicianAction.emit(product);
  }
  sendToConsultant(product:any):void{
    this.assignConsultantAction.emit(product);
  }
  addAdminNotes(product:any):void{
    this.addAdminNotesAction.emit(product);
  }
  isVirtualConsultation(product:any):void{
    this.virtualConsultationAction.emit(product);
  }
  uploadFilePopup(product:any):void{
    this.uploadFilePopupAction.emit(product);
  }
  viewPatientCaseDetails(data: any) {
    const route = 'landing/patientCase/' + btoa(JSON.stringify(data))
    this._router.navigate([route]);
  }
}
